export var HeaderAndFooterVariant;
(function (HeaderAndFooterVariant) {
    HeaderAndFooterVariant["Static"] = "static";
    HeaderAndFooterVariant["Dynamic"] = "dynamic";
})(HeaderAndFooterVariant || (HeaderAndFooterVariant = {}));
export var DeviceType;
(function (DeviceType) {
    DeviceType["Mobile"] = "mobile";
    DeviceType["Desktop"] = "desktop";
    DeviceType["Tablet"] = "tablet";
    DeviceType["NativeAppWebView"] = "nativeAppWebView";
})(DeviceType || (DeviceType = {}));
